import React, { useState, useEffect } from 'react';
import { Box, Typography, TextField, Button, Table, TableHead, TableRow, TableCell, TableBody, Paper } from '@mui/material';
import axios from 'axios';

const Overtime = () => {
  const [requests, setRequests] = useState([]);
  const [newReq, setNewReq] = useState({ employee: '', date: '', hours: '' });

  useEffect(() => {
    fetchRequests();
  }, []);

  const fetchRequests = async () => {
    try {
      const res = await axios.get('/api/overtime-requests');
      setRequests(res.data);
    } catch {
      setRequests([]);
    }
  };

  const handleChange = (e) => setNewReq({ ...newReq, [e.target.name]: e.target.value });
  const handleAdd = async () => {
    if (!newReq.employee || !newReq.date || !newReq.hours) return;
    try {
      await axios.post('/api/overtime-requests', { ...newReq, hours: Number(newReq.hours) });
      fetchRequests();
      setNewReq({ employee: '', date: '', hours: '' });
    } catch {}
  };
  const handleStatus = async (id, status) => {
    try {
      await axios.patch(`/api/overtime-requests/${id}`, { status });
      fetchRequests();
    } catch {}
  };

  return (
    <Box sx={{ maxWidth: 600, mx: 'auto', mt: 4 }}>
      <Typography variant="h4" gutterBottom>Fazla Mesai Talepleri</Typography>
      <Paper sx={{ p: 2, mb: 2 }}>
        <Typography variant="h6">Yeni Talep</Typography>
        <TextField label="Çalışan" name="employee" value={newReq.employee} onChange={handleChange} sx={{ mr: 1 }} />
        <TextField label="Tarih" name="date" type="date" value={newReq.date} onChange={handleChange} sx={{ mr: 1 }} InputLabelProps={{ shrink: true }}/>
        <TextField label="Saat" name="hours" type="number" value={newReq.hours} onChange={handleChange} sx={{ mr: 1, width: 80 }} />
        <Button variant="contained" onClick={handleAdd}>Ekle</Button>
      </Paper>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Çalışan</TableCell>
            <TableCell>Tarih</TableCell>
            <TableCell>Saat</TableCell>
            <TableCell>Durum</TableCell>
            <TableCell>İşlem</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {requests.map((r) => (
            <TableRow key={r.id}>
              <TableCell>{r.employee}</TableCell>
              <TableCell>{r.date}</TableCell>
              <TableCell>{r.hours}</TableCell>
              <TableCell>{r.status}</TableCell>
              <TableCell>
                {r.status === 'Bekliyor' && (
                  <>
                    <Button size="small" color="success" onClick={() => handleStatus(r.id, 'Onaylandı')}>Onayla</Button>
                    <Button size="small" color="error" onClick={() => handleStatus(r.id, 'Reddedildi')}>Reddet</Button>
                  </>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  );
};

export default Overtime;
